import Link from 'next/link'

import { typographyVariants } from '@ui/web/lib'
import { CODA_FORM_CONTACT_US, HELP_URL, LEGAL_NAME, WHATSAPP_LINK } from '@helper/utils/core'
import cn from '@config/tailwind/cn'

import { poppins } from '~/font'
import { LANDING_ROUTES } from './links'

const FOOTER_SECTIONS = [
  {
    title: 'Sumber Daya',
    links: [
      { label: 'Inspirasi Mengajar', href: LANDING_ROUTES.teachingBlog, external: false },
      { label: 'Sumber daya gratis', href: LANDING_ROUTES.sumberDaya, external: false },
      { label: 'Program beasiswa', href: LANDING_ROUTES.beasiswa, external: false },
    ],
  },
  {
    title: 'Dukungan',
    links: [
      { label: 'Pusat Bantuan', href: HELP_URL, external: true },
      { label: 'Tanya & Kolaborasi', href: CODA_FORM_CONTACT_US, external: true },
      { label: 'Kontak Bantuan', href: WHATSAPP_LINK, external: true },
    ],
  },
  {
    title: 'Pernyataan',
    links: [
      { label: 'Ketentuan Layanan', href: LANDING_ROUTES.terms, external: false },
      { label: 'Kebijakan Privasi', href: LANDING_ROUTES.privacy, external: false },
    ],
  },
] as const

export function SiteFooter() {
  return (
    <footer className={cn('bg-neutral-black text-neutral-white px-4 pt-12 pb-8 md:px-8', poppins.className)}>
      <div className='mx-auto flex max-w-295 flex-col gap-8'>
        <div className='flex flex-wrap gap-x-20 gap-y-8'>
          {FOOTER_SECTIONS.map((section) => (
            <div key={section.title} className='flex flex-col gap-3'>
              <span className={cn(typographyVariants({ variant: 'title-sm' }), 'text-navy-30')}>{section.title}</span>
              {section.links.map((link) => (
                <Link
                  key={link.label}
                  href={link.href}
                  target={link.external ? '_blank' : undefined}
                  rel={link.external ? 'noopener noreferrer' : undefined}
                  className={cn(typographyVariants({ variant: 'body-md' }), 'text-neutral-white hover:underline')}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          ))}
        </div>
        <div className='bg-navy-90 h-px' />
        <span className={cn(typographyVariants({ variant: 'body-md' }), 'text-navy-20')}>© {LEGAL_NAME}</span>
      </div>
    </footer>
  )
}
